import React, { useEffect, useState, useRef } from 'react';
import appleDownload from '../../assets/images/about/about_section_6_download_apple.svg';
import googleDownload from '../../assets/images/about/about_section_6_download_google.svg';

function AboutSection6() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: 0.05, // 섹션이 20% 이상 보일 때 트리거
        rootMargin: '-20px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <>
      <section ref={sectionRef} className="h-[600px] md:h-[600px] w-full flex items-center justify-center bg-[#F8F8F8] py-[40px] md:py-0">
        <div className={`container mx-auto flex flex-col items-center justify-center h-full px-4 md:px-0 transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[30px]'}`}>
          <h2 className="text-[32px] md:text-[40px] leading-[140%] font-pretendard font-bold font-semibold text-black mb-[56px] text-center">
            <span className="block md:hidden">폰피쉬,<br />지금 바로 경험해보세요!</span>
            <span className="hidden md:block">폰피쉬, 지금 바로 경험해보세요!</span>
          </h2>
          <div className="flex flex-col gap-[24px] items-center">
            <a
              href="https://apps.apple.com/us/app/ponpish-%ED%8F%BC%ED%94%BC%EC%89%AC/id6743611917"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-black text-white px-6 py-[10px] rounded-full text-lg font-semibold shadow-md hover:bg-gray-800 transition">
              <img src={appleDownload} alt="App Store" className="w-[140px] md:w-[180px] h-[40px] md:h-[52px]" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.chaenggigo.ponpish"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-black text-white px-6 py-[10px] rounded-full text-lg font-semibold shadow-md hover:bg-gray-800 transition">
              <img src={googleDownload} alt="Google Play" className="w-[140px] md:w-[180px] h-[40px] md:h-[52px]" />
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutSection6; 